t = require('views/internal/teacup-with-helpers')('observer_list')

module.exports = ->
  t.ul { class: 'pop-over-member-list js-list ' + t.mustacheBlock('__ed', (-> 'js-list-draggable-board-members')) }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/observer_list.coffee